import { Injectable } from '@angular/core';
import * as ExcelJS from "exceljs/dist/exceljs.min.js";
import moment from 'moment';
import saveAs from "file-saver";

@Injectable({
  providedIn: 'root'
})
export class UploadFromTemplateService {

  constructor() { }

  downloadTemplate(fields: string[], domain: string) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
    const header = worksheet.addRow(fields);
    header.font = { bold: true };
    header.alignment = { vertical: 'middle', horizontal: 'left' };
    header.height = 20;
    worksheet.columns?.forEach((column: any) => {
      column.width = 20;
    });
    worksheet.addRow([]);
    workbook.xlsx.writeBuffer().then((buffer: any) => {
      this.saveAsExcelFile(buffer, domain);
    });
  }

  exportData(dataColumns: any[], data: any[], domain: string) {
    let columns = [...dataColumns];
    // Remove Action column
    if (columns.length > 0 && (columns[columns.length - 1] === 'Action' || columns[columns.length - 1].caption === 'Action')) {
      columns.pop();
    }
    // Map columns to ExcelJS columns
    columns = columns.map((column: any) => {
      return {
        header: column.caption,
        key: column?.dataField || column?.cellTemplate,
        width: column?.width || 20
      };
    });
    // Create and download Excel file
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
    worksheet.columns = columns;
    const header = worksheet.columns;
    header.font = { bold: true };
    header.alignment = { vertical: 'middle', horizontal: 'left' };
    worksheet.addRows(data);
    workbook.xlsx.writeBuffer().then((buffer: any) => {
      this.saveAsExcelFile(buffer, domain);
    });
  }

  saveAsExcelFile(buffer: any, domain: string): void {
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const dateTime = moment().format('YYYY-MM-DD-HH-mm');
    saveAs(blob, `${domain}-${dateTime}.xlsx`);
  }

  async readExcelFile(file: any, callback: Function) {
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      const arrayBuffer: any = fileReader.result;
      const data = new Uint8Array(arrayBuffer);
      const arr = new Array();
      for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      const bstr = arr.join("");
      const workbook = new ExcelJS.Workbook();
      workbook.xlsx.load(bstr).then(() => {
        const worksheet = workbook.getWorksheet(1);
        const firstRow = worksheet.getRow(1);
        const header = [];
        firstRow.eachCell((cell, number) => {
          header.push(cell.value);
        });
        const data = [];
        worksheet.eachRow((row, number) => {
          if (number > 1) {
            const rowData = {};
            row.eachCell((cell, number) => {
              rowData[header[number - 1]] = cell.value;
            });
            data.push(rowData);
          }
        });
        callback(data);
      });
    };
    fileReader.readAsArrayBuffer(file);
  }

}
